import { Mark } from '@tiptap/core'

type anchorAttrs = {
  id: string | null
  class: string
}

export type AnchorOptions = {
  id: {
    default: string
  }
}

declare module '@tiptap/core' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Commands<ReturnType> {
    anchor: {
      setAnchor: (arg: string) => ReturnType
      removeAnchor: () => ReturnType
    }
  }
}

export default Mark.create<AnchorOptions>({
  name: 'anchor',

  addAttributes() {
    return {
      id: {
        default: '',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span',
        getAttrs: (node: HTMLElement): anchorAttrs | false => {
          const anchorId = node.getAttribute('id')

          if (anchorId?.length) {
            return {
              class: 'ProseMirror__anchor',
              id: node.getAttribute('id'),
            }
          }

          return false
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const idTreated = String(HTMLAttributes.id)
      .replace(/\s/g, '')
      .toLocaleLowerCase()

    const attrs = {
      class: 'ProseMirror__anchor',
      id: idTreated,
      'data-id': idTreated,
    }

    const tooltipText = [
      'span',
      {
        class: 'ProseMirror__tooltip-text',
        'data-text': `#${idTreated}`,
      },
    ]

    return [
      'span',
      {
        class: 'ProseMirror__tooltip',
      },
      tooltipText,
      ['span', attrs, 0],
    ]
  },

  addCommands() {
    return {
      setAnchor:
        (value: string) =>
        ({ commands }): boolean => {
          return commands.setMark('anchor', { id: value })
        },

      removeAnchor:
        () =>
        ({ commands }): boolean => {
          return commands.unsetMark('anchor')
        },
    }
  },
})
